import Icon from "@material-ui/icons/Person";
import AcademicTermCreate from "./AcademicTermCreate";
import AcademicTermEdit from "./AcademicTermEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "academicTerms",
  edit: AcademicTermEdit,
  create: AcademicTermCreate,
  icon: Icon,
};
